import {getCandyMachineCreator} from './candy-machine';
import {PublicKey} from '@solana/web3.js';
import {programs} from '@metaplex/js';

const Metadata = programs.metadata.Metadata;

export const getNftsFromWallet = async function (connection, candyMachineId, walletAddress) {
  const creator = await getCandyMachineCreator(new PublicKey(candyMachineId));
  const creatorPublicKeyString = creator[0].toString();

  const nftsmetadata = await Metadata.findDataByOwner(connection, walletAddress);
  const nftsPromises = nftsmetadata.map(async metadata => {
    try {
      if (metadata.data.creators[0].address === creatorPublicKeyString) {
        const jsonUri = metadata.data.uri;
        if (jsonUri) {

          const jsonResponse = await fetch(jsonUri);
          const json = await jsonResponse.json();
          return {mint: metadata.mint, metadata: metadata.data, json};
        } else {
          return {mint: metadata.mint, metadata: metadata.data, json: {}};
        }
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
      return null;
    }

  });
  const nfts = await Promise.all(nftsPromises);
  return nfts.filter(nft => !!nft);
};
